import { useSelector } from "react-redux";

export const useIsGPUser = () => {
  const auth = useSelector(({ auth }) => auth);
  const {user:{company:{id,companyType}}} = auth;
  return id===1 && companyType==="GP"
};
